'use client';

import React from 'react';
import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch';

const SectionButtons = ({
  title,
  onClick,
  active = false,
  countOverride = null,
}) => {
  const { results } = useInstantSearch();
  const count = countOverride ?? results?.nbHits ?? '';

  return (
    <div className="px-0 py-1.5 max-[767px]:p-0 hover:text-brand">
      <button
        type="button"
        className={classNames(
          'w-full bg-white text-center md:text-left text-base',
          {
            'font-bold': active,
          }
        )}
        onClick={onClick}
      >
        {`${title} ${`(${count})` ?? ''}`}
      </button>
    </div>
  );
};

export default SectionButtons;
